var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconHeart04 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M13.322.923a5.997 5.997 0 0 1 8.295 5.543 6 6 0 0 1-1.758 4.242L11 19.567l-8.859-8.86a5.999 5.999 0 0 1 8.484-8.483L11 2.6l.376-.376c.556-.557 1.218-.999 1.946-1.3M15.618 2.2A4.26 4.26 0 0 0 12.6 3.45L11 5.05 9.398 3.45a4.265 4.265 0 1 0-6.032 6.032L11 17.116l7.634-7.634A4.264 4.264 0 0 0 15.617 2.2",
  clipRule: "evenodd"
})));
export default SvgIconHeart04;